/* eslint camelcase: 0 */

import { UserActionCollection as Data } from '@/typings/api/User'
import { Model } from '@/helpers/Model'


export class UsersActionsModel extends Model<Data> {
}
